<template>
  <div class="Tab">
    <el-table :data="tableData">
      <el-table-column
        prop="orderNumber"
        :index="NIndex"
        label="订单ID"
        width="210"
      >
      </el-table-column>
      <el-table-column
        :label="'企业名称\n(统一社会信用代码)'"
        width="220"
        show-overflow-tooltip
        ><template slot-scope="scope">
          <div>{{ scope.row.customerName }}</div>
          <div>({{ scope.row.customerCreditCode }})</div>
        </template></el-table-column
      >
      <el-table-column label="服务类型" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{
            belongTo == "变更"
              ? "变更"
              : belongTo == "资质"
              ? scope.row.handleTypeName
              : belongTo == "标书"
              ? "制作"
              : belongTo == "评估"
              ? "评估"
              : belongTo == "审计"
              ? "审计"
              : belongTo == "筹划"
              ? "税务筹划"
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="服务类别" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{
            belongTo == "变更"
              ? scope.row.businessTypeName
              : belongTo == "资质"
              ? "资质"
              : belongTo == "标书"
              ? scope.row.businessTypeName
              : belongTo == "评估"
              ? scope.row.businessTypeName
              : belongTo == "审计"
              ? scope.row.businessTypeName
              : belongTo == "筹划"
              ? scope.row.businessTypeName
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="资质名称" show-overflow-tooltip width="120" v-if="belongTo == '资质'">
        <template slot-scope="scope">
          <span>{{ scope.row.credentialName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="企业类型"
        prop="customerCompanyTypeName"
      >
      </el-table-column>
      <el-table-column
        prop="PayTaxes"
        label="性质"
        v-if="BidDocument == 'xf'"
      >
      </el-table-column>
      <el-table-column
        prop="projectName"
        label="项目名称"
        v-if="BidDocument == 'bs'"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="bidDocumentName"
        label="标书名称"
        v-if="BidDocument == 'bs'"
        show-overflow-tooltip
        width="180"
      >
      </el-table-column>

      <el-table-column label="状态" width="120"
        ><template slot-scope="scope">
          <span :class="$tool.getProxyStatusClass(scope.row)" :style="{ color: $tool.getProxyStatusColor(scope.row) }">{{ scope.row.statusName }}</span>
        </template></el-table-column
      >
      <el-table-column
        prop="createTime"
        label="提交时间"
        show-overflow-tooltip
        width="180"
      >
      </el-table-column>
      <el-table-column label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <span class="span-Operation" @click="handelDetails(0, scope.row)"
            >详情信息</span
          >
          <span
            class="span-Operation"
            @click="handelDetails(1, scope.row)"
            v-if="scope.row.refundButton == true"
            >申请退款</span
          >
          <span
            class="span-Operation"
            @click="handelHesitation(scope.row)"
            v-if="scope.row.refundButton == true"
            >立即办理</span
          >
          <span
            class="span-Operation"
            @click="handelEvaluation(scope.row)"
            v-if="scope.row.status == 3"
            >服务评价</span
          >

          <!-- <span
            class="span-Operation"
            v-if="scope.row.status == 2"
            @click="handelAndLeProcess(1, scope.row)"
            >重新提交</span
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 立即办理弹窗 -->
    <Hesitation
      :VisibleHesitation="VisibleHesitation"
      @handleCloseHesitation="VisibleHesitation = false"
      @handleUnHesitation="handleUnHesitation"
    ></Hesitation>
  </div>
</template>

<script>
import Hesitation from "../../../Bookkeeping/components/IndexCom/Hesitation.vue"; //立即办理弹窗
export default {
  // 组件参数 接收来自父组件的数据
  props: {
    tableData: {},
    BidDocument: {},
    belongTo: {}, //区分 变更/资质
    pagingObj: {},
  },

  // 组件状态值
  data() {
    return {
      VisibleHesitation: false, //立即办理弹窗
      Details: {}, //被操作项的详情数据
    };
  },
  watch: {
    // // 监听
    // visibleImport: {
    //   handler(newSs, old) {},
    //   immediate: false,
    // },
  },
  components: {
    Hesitation, //立即办理弹窗
  },
  // 组件初始化
  created() {},
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {},
  // 组件方法
  methods: {
    // 列表刷新
    Refresh() {
      this.$emit("Refresh");
    },
    // 立即办理确定
    handleUnHesitation() {
      var apiUrl1 = "/global/proxy/businessUpdateProcess";
      var apiUrl2 = "/global/proxy/credentialProcess";
      var apiUrl3 = "/global/proxy/bidDocumentProcess";
      var apiUrl4 = "/global/proxy/valuationProcess";
      var apiUrl5 = "/global/proxy/auditClearingProcess";
      var apiUrl6 = "/global/proxy/taxPlanningProcess";

      this.$tool
        .InvoiceProcess(
          this.belongTo == "变更"
            ? apiUrl1
            : this.belongTo == "资质"
            ? apiUrl2
            : this.belongTo == "标书"
            ? apiUrl3
            : this.belongTo == "评估"
            ? apiUrl4
            : this.belongTo == "审计"
            ? apiUrl5
            : this.belongTo == "筹划"
            ? apiUrl6
            : "",
          this.Details.orderNumber,
          0
        )
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.Refresh();
          }
        });
      this.VisibleHesitation = false;
    },
    //立即办理
    handelHesitation(row) {
      if (!this.$checkAction()) return;
      this.Details = row;
      this.VisibleHesitation = true;
    },
    // 列表 - 查看
    handelDetails(num, row) {
      if (num == 1) {
        if (!this.$checkAction()) return;
        this.$emit("handelDetails", num, row);
      } else {
        this.$emit("handelDetails", num, row);
      }
    },
    // 列表重新提交
    handelAndLeProcess(num, row) {
      this.$emit("handelAndLeProcess", num, row);
    },
    // 服务评价
    handelEvaluation(row) {
      if (!this.$checkAction()) return;
      this.$emit("handelEvaluation", row);
    },

    //表格分页序号
    NIndex(index) {
      // 当前页数 - 1 * 每页数据条数 + 1
      const page = this.pagingObj.currentPage; // 当前页码
      const pagesize = this.pagingObj.pageSize; // 每页条数
      return index + 1 + (page - 1) * pagesize;
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}
/* 滚动条滑块（可拖动部分）颜色 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
// 兼容火狐
::v-deep .el-table__body-wrapper {
  /* 控制滚动条粗细（对应 WebKit 的 height:8px） */
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  /* 控制滑块和轨道颜色（对应 WebKit 的 thumb 和 track） */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
.Tab {
  width: 100%;
  .span-Operation {
    color: #409eff ;
    margin-left: 10px;
    cursor: pointer;
  }
  .span-Operation:nth-child(1) {
    margin-left: 0px;
  }
}
</style>
